module.exports = __webpack_public_path__ + "static/media/logo.d813f870.png";